import AirtableTable from "../AirtableTable";
import { ArtistAmbassador } from "../models";
import { airtableFields, airtableTables } from "../schema";

export const artistAmbassadorFieldIds = airtableFields.artistAmbassadors;

export class ArtistAmbassadorTable extends AirtableTable<ArtistAmbassador> {
  constructor(instance: any) {
    super(instance, airtableTables.artistAmbassadors);

    this.fields = [
      artistAmbassadorFieldIds.name,
      artistAmbassadorFieldIds.openForBooking,
      artistAmbassadorFieldIds.photo,
      artistAmbassadorFieldIds.bio,
      artistAmbassadorFieldIds.workshopDescription,
      artistAmbassadorFieldIds.professionCraft,
      artistAmbassadorFieldIds.field,
      artistAmbassadorFieldIds.location,
      artistAmbassadorFieldIds.events,
    ];
  }

  getOpenForBooking = () => {
    return this.list({ sort: [{ field: artistAmbassadorFieldIds.name, direction: "asc" }] })
      .then((items: any[]) => items
        .filter((item) => Boolean(item[artistAmbassadorFieldIds.openForBooking]))
        .map((item) => ({ ...item, Location: item[artistAmbassadorFieldIds.location] })));
  };
}
